<div class="app-scroll">
  <app-mobile-notification></app-mobile-notification>
  <router-outlet></router-outlet>
</div>